

'use strict';

var OpeningHours = /** @class */ (function () {
    function OpeningHours(wrapper) {
        if (!$(wrapper).length == 0) {
            this.$wrapper = $(wrapper);
            this.className = $(wrapper).get(0).className;
            this.dateStart = this.dateCurrent = this.getDateFromString($(wrapper).find(".date-start").val());
            this.init();
        }
    }
    /** Init **/
    OpeningHours.prototype.init = function () {
        this.addEvents();
    };
    /** End Init **/

    /** Events **/
    OpeningHours.prototype.addEvents = function () {
        var self = this;

        this.$wrapper.on("click", "." + self.className + "__button", function (e) {
            e.preventDefault();
            var $elem = $(e.currentTarget);
            var nbDays = 7;
            var date = new Date(self.dateCurrent);
            var day = self.dateCurrent.getDate();
          
            if ($elem.hasClass('-next')) {
                var nextDate = new Date(date.setDate(day + nbDays));


                self.dateCurrent = nextDate;
                $(this).siblings(".-hide").removeClass("-hide");


            } else if ($elem.hasClass("-prev") && !$elem.hasClass("-hide")) {
                var nextDate = new Date(date.setDate(day - nbDays));
                if (nextDate.getTime() === self.dateStart.getTime()) {
                    $(this).addClass("-hide");
                }
                self.dateCurrent = nextDate;
               
            }
            self.getSchedule()
        })           
    };
    /** End Events **/
    /** AJAX **/
    OpeningHours.prototype.getSchedule = function () {
        var self = this;
        var dateFormat = this.formatDate(this.dateCurrent);

        $.get("/Jewellery/GetStorePlanning?IdJewellery=" + $("#idJewellery").val() + "&dt=" + dateFormat, function (data) {
            
            $("." + self.className + "__wrapper").html(data);
        })
    };
    /** END AJAX **/


    /* DATE FORMAT */
    OpeningHours.prototype.getDateFromString = function (string) {
        var date = string.split("/");
        return new Date(date[2], parseInt(date[1]) - 1, date[0])
    };
    OpeningHours.prototype.formatDate = function (noFormatDate) {
        var year = noFormatDate.getFullYear();
        var month = ('0' + (noFormatDate.getMonth() + 1)).slice(-2)
        var day = ('0' + noFormatDate.getDate()).slice(-2)
        return year + "-" + month + "-" + day;
    };

    /* END DATE FORMAT */


    return OpeningHours;
}());

